module.exports = __webpack_public_path__ + "img/2_34.518ba781.png";